<template>
    <div>
        <div class="select">

            <el-select style="width:100px; padding-right: 10px;" v-model="value" clearable placeholder="请选择"
                       @change="province_change">
                <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                >
                </el-option>
            </el-select>
            <el-select style="width:150px; padding-right: 10px;" v-model="cityvalue" clearable placeholder="请选择">
                <el-option
                        v-for="item in cityoptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
<!--            <el-select v-model="maintypevalue" style="width:250px; padding-right: 10px;" clearable placeholder="请选择"-->
<!--                       @change="maintype_change" disabled>-->
<!--                <el-option-->
<!--                        v-for="(item, key) in maintypeoptions"-->
<!--                        :key="key"-->
<!--                        :label="item.label"-->
<!--                        :value="item.value">-->
<!--                </el-option>-->
<!--            </el-select>-->
<!--            <el-select v-model="typevalue" style="width:250px; padding-right: 10px;" clearable placeholder="请选择"-->
<!--                       disabled>-->
<!--                <el-option-->
<!--                        v-for="item in typeoptions"-->
<!--                        :key="item.value"-->
<!--                        :label="item.label"-->
<!--                        :value="item.value">-->
<!--                </el-option>-->
<!--            </el-select>-->
<!--            <el-select style="width:120px; padding-right: 10px;" v-model="eiatypevalue" clearable placeholder="请选择"-->
<!--                       disabled>-->
<!--                <el-option-->
<!--                        v-for="item in eiatypeoptions"-->
<!--                        :key="item.value"-->
<!--                        :label="item.label"-->
<!--                        :value="item.value">-->
<!--                </el-option>-->
<!--            </el-select>-->

<!--            <el-date-picker-->
<!--                    style="width:300px; padding-right: 10px;"-->
<!--                    v-model="valueTime"-->
<!--                    value-format="yyyy-MM-dd 00:00:00"-->
<!--                    type="daterange"-->
<!--                    align="right"-->
<!--                    unlink-panels-->
<!--                    range-separator="至"-->
<!--                    start-placeholder="开始日期"-->
<!--                    end-placeholder="结束日期"-->
<!--                    :picker-options="pickerOptions"-->
<!--                    @change="time_change" disabled>-->
<!--            </el-date-picker>-->
            <el-input style="width: 250px; padding-left:10px;"
                      placeholder="请输入检索关键字后按回车"
                      v-model="input"
                      clearable
                      @keydown.enter.native="search"
            >
            </el-input>
            <el-button type="primary" style="margin-left:10px;" @click="search">查询</el-button>
            <el-tooltip
                    class="item"
                    effect="dark"
                    placement="top">
                <span slot="content" style="font-size: 10px; line-height:25px">每次导出数据最大限值为2000条，若超过限值，建议优化查询条件。</span>
                <el-button type="primary" @click="open">导出</el-button>
            </el-tooltip>
        </div>
        <div class="table">
            <el-table
                    :data="tableData"
                    stripe
                    style="width: 100%"
                    height="100%"
                    cell-style="padding:17px"

            >
                <!--                <el-table-column-->
                <!--                        fixed-->
                <!--                        type="expand">-->
                <!--                    <template slot-scope="props">-->
                <!--                        <el-form label-position="left" class="demo-table-expand" inline-->
                <!--                                 style="background-color: #DFEBF5 ">-->
                <!--                            <el-form-item label="未完待续。">-->
                <!--                                <span>{{ props.row.id }}</span>-->
                <!--                            </el-form-item>-->


                <!--                        </el-form>-->
                <!--                    </template>-->

                <!--                </el-table-column>-->
                <!--                <el-table-column-->
                <!--                        fixed-->
                <!--                        sortable-->
                <!--                        prop="id"-->
                <!--                        label="ID"-->
                <!--                        width="80">-->
                <!--                </el-table-column>-->
                <el-table-column
                        fixed
                        align="center"
                        prop="id"
                        label="序号"
                        width="90">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="compile_unit_name"
                        label="编制单位名称"
                        :show-overflow-tooltip='true'
                        width="200">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="compile_unit_scid"
                        label="编制单位信用代码"
                        width="240">
                </el-table-column>

                <el-table-column
                        align="center"
                        prop="province"
                        label="所在省"
                        width="90">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="city"
                        label="所在市"
                        width="100">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="district"
                        label="所在区（县）"
                        :show-overflow-tooltip='true'
                        width="180">
                </el-table-column>

                <el-table-column
                        align="center"
                        prop="baogaoshu"
                        label="编制报告书数量"
                        width="150">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="baogaobiao"
                        label="编制报告表数量"
                        width="150">
                </el-table-column>


            </el-table>
            <div class="page">
                <div class="pa">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 30, 40, 50]"
                            :page-size=pageSize
                            layout="total, sizes, prev, pager, next, jumper"
                            :total=total>
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import screenfull from 'screenfull'
    import {compile_unit_download} from "../../../../network/request";
    import {CompileUnitDataSearch} from "../../../../network/projectAnalysis";
    import {Province} from "../../../../network/utils";
    import {Type} from "../../../../network/utils";

    export default {
        name: "CompileUnitSearchv2",
        data() {
            return {
                options: [],
                cityoptions: [],
                value: '全国',
                cityvalue: '全省',
                maintypeoptions: [],
                maintypevalue: "全部大类",
                typeoptions: [],
                typevalue: "全部小类",
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                        {
                            text: '最近一年',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                    ]
                },
                valueTime: [],
                minMaxTime: [],
                eiatypevalue: "全部类型",
                eiatypeoptions: [
                    {value: "全部类型", label: "全部类型"},
                    {value: "报告书", label: "报告书"},
                    {value: "报告表", label: "报告表"},

                ],
                input: "",
                tableData: [],
                total: 0,
                currentPage: 1,
                pageSize: 10,
            }
        },
        methods: {
            open() {
                var mess = '本次查询数据共 ' + this.total + " 条，确认导出？";
                if (this.total > 2000) {
                    mess = '本次查询数据共 ' + this.total + " 条，超过导出数据最大限制量 2000 ，确认导出？";
                }
                ;
                this.$confirm(mess, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '请求导出成功!'

                        });
                        this.download()
                    },
                ).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消导出操作'
                    });
                });
            },
            province_change(val) {
                this.cityoptions = [];
                if (val === "全国") {

                    this.cityoptions.unshift({value: "全省", label: "全省"})
                    this.cityvalue = "全省"

                } else {
                    Province(val).then(response => {
                        for (var i = 0; i < response.data.length; i++) {
                            this.cityoptions.push({value: response.data[i]['city'], label: response.data[i]['city']})
                        }
                        this.cityoptions.unshift({value: "全省", label: "全省"})
                        this.cityvalue = "全省"
                    });
                }

            },
            maintype_change(val) {
                this.typeoptions = [];
                if (val === "全部大类") {

                    this.typeoptions.unshift({value: "全部小类", label: "全部小类"})
                    this.typevalue = "全部小类"

                } else {
                    Type(val).then(response => {
                        for (var i = 0; i < response.data.length; i++) {
                            this.typeoptions.push({
                                value: response.data[i]['type_name'],
                                label: response.data[i]['type_name']
                            })
                        }
                        this.typeoptions.unshift({value: "全部小类", label: "全部小类"})
                        this.typevalue = "全部小类"
                    });
                }

            },
            time_change(val) {
                this.minMaxTime = val
            },
            getFullCreeen() {
                if (screenfull.isEnabled) {
                    screenfull.toggle()
                }
            },
            download() {
                let province = (this.value === "全国") ? '' : this.value;
                let cityvalue = (this.cityvalue === "全省") ? '' : this.cityvalue;
                window.location.href = compile_unit_download(province, cityvalue)
            },
            getFormatDate(date) {
                let Str = date.getFullYear() + '-' +
                    ((date.getMonth() + 1).toString().length == 1 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-' +
                    (date.getDate().toString().length == 1 ? '0' + date.getDate() : date.getDate()) + ' ' +
                    (date.getHours().toString().length == 1 ? '0' + date.getHours() : date.getHours()) + ':' +
                    (date.getMinutes().toString().length == 1 ? '0' + date.getMinutes() : date.getMinutes()) + ':' +
                    (date.getSeconds().toString().length == 1 ? '0' + date.getSeconds() : date.getSeconds());
                return Str;
            }
            ,
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = val;

                let province = (this.value === "全国") ? '' : this.value;
                let cityvalue = (this.cityvalue === "全省") ? '' : this.cityvalue;

                CompileUnitDataSearch(province, cityvalue, this.pageSize, this.currentPage, this.input).then(response => {
                    this.tableData = response.data['results'];

                    this.total = response.data['count']
                });
            }
            ,
            handleCurrentChange(val) {
                this.currentPage = val;

                let province = (this.value === "全国") ? '' : this.value;
                let cityvalue = (this.cityvalue === "全省") ? '' : this.cityvalue;

                // console.log(province, cityvalue, maintypevalue, typevalue, eiatypevalue, minttime, maxtime, this.pageSize);
                CompileUnitDataSearch(province, cityvalue, this.pageSize, this.currentPage, this.input).then(response => {
                    this.tableData = response.data['results'];

                    this.total = response.data['count']
                });

            }
            ,
            search() {
                let province = (this.value === "全国") ? '' : this.value;
                let cityvalue = (this.cityvalue === "全省") ? '' : this.cityvalue;

                // console.log(province, cityvalue, maintypevalue, typevalue, eiatypevalue, minttime, maxtime, this.pageSize);
                CompileUnitDataSearch(province, cityvalue, this.pageSize, this.page, this.input).then(response => {

                    this.tableData = response.data['results'];

                    this.total = response.data['count']
                });
            }
        }
        ,
        created() {
            this.valueTime = [new Date(new Date().getTime() - 3600 * 1000 * 24 * 365), new Date()]
            CompileUnitDataSearch().then(response => {
                this.tableData = response.data['results'];
                this.total = response.data['count']
            });


            Province().then(response => {
                for (var i = 0; i < response.data.length; i++) {
                    this.options.push({value: response.data[i]['city'], label: response.data[i]['city']})
                }
                this.options.unshift({value: "全国", label: "全国"})
            });

            Type().then(response => {
                for (var i = 0; i < response.data.length; i++) {
                    this.maintypeoptions.push({
                        value: response.data[i]['type_name'],
                        label: response.data[i]['type_name']
                    })
                }
                this.maintypeoptions.unshift({value: "全部大类", label: "全部大类"})
            });
        }
    }
</script>

<style scoped>
    .table {
        height: 650px;
        width: 1200px;
        margin-left: 10px;
    }


    .page {
        background-color: #f7f7f7;
        z-index: 10;
        float: left;
        width: 100%;

    }

    .pa {
        display: flex;
        /*margin-left: 400px;*/
        align-items: center;
        justify-content: center;

    }

    .select {
        /*background-color: #bd81bb;*/
        width: 1200px;
        z-index: -0;
        margin-top: 35px;
        padding: 10px;
    }

</style>